module.exports = __webpack_public_path__ + "static/media/backgroundLight.adbccee0.png";